module.exports = __webpack_public_path__ + "static/media/parallax01.abe8bf4d.svg";